import { render, staticRenderFns } from "./Land.vue?vue&type=template&id=366a3cd8&"
import script from "./Land.vue?vue&type=script&lang=js&"
export * from "./Land.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports